import React, { FC, ReactElement, ReactNode, useState } from 'react';
import Card from '../card/card';
import CardBody from '../card/card-body';
import CardHeader from '../card/card-header';

import closeIcon from '../../images/close.svg';
import burger from '../../images/TOC.svg';
import WizardSideBar from '../wizard-sidebar/wizard-sidebar';

type Props = {
    children: ReactNode[],
    step: number,
    name: string,
    onClose: () => void,
    masterImages?: any,
    onSelectedImage?: any
    sidebarSteps?: {
        title: string,
        description: string,
        substeps: { title: string }[]
    }[]
    onSetPrimary?: any
    className?: string
};

const Wizard: FC<Props> = ({ children, step, name, onClose, sidebarSteps = [], masterImages, onSelectedImage, onSetPrimary, className }) => {
    const hideDivStyle = { display: "none" }
    const childWrap = (stepIndex) => (stepIndex === step) ? {} : hideDivStyle;

    const nestedChildElements = child => {
        const reactChild = child as ReactElement;
        return reactChild?.props.children;
    }

    const flattenChildren = (childrenTree) => {
        return childrenTree.map((child) => {
            const nestedChildren = nestedChildElements(child);

            return nestedChildren ? [child, nestedChildren] : [child];
        });
    }

    const childElements = () => {

        return flattenChildren(children).flat().map((child, i) => <div key={i} style={childWrap(i)} className="h-full overflow-hidden">{child}</div>);
    };

    const [isExpanded, setIsExpanded] = useState(true);

    return <div className={className ? className : `${masterImages ? 'master-image-wizard' : 'wizard relative'}`} id='wizard'>
        <Card style={{ maxHeight: 560 }} className="h-full flex flex-col">
            <CardHeader className={`flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
                <div className="flex flex-row">
                    {/* <img src={burger} onClick={() => setIsExpanded(!isExpanded)} className={`cursor-pointer ml-2 ${step === 0 ? 'hidden' : ''}`} /> */}
                    <p className="pl-3 font-bold font text-white">{name}</p>
                </div>
                <img src={closeIcon} onClick={onClose} className="cursor-pointer mr-2" id='closeWizardIcon' />
            </CardHeader>
            <div className={`flex flex-row h-full`}>
                <WizardSideBar onSetPrimary={onSetPrimary} onSelectedImage={onSelectedImage} masterImages={masterImages} isExpanded={isExpanded} step={step} steps={sidebarSteps}></WizardSideBar>
                <CardBody className={`px-2 h-full  ${sidebarSteps && sidebarSteps.length > 0 ? '' : 'w-full'}`} style={sidebarSteps && sidebarSteps.length > 0 ? { minWidth: 560, maxHeight: 510 } : { maxHeight: 510 }}>
                    {childElements()}
                </CardBody>

            </div>
        </Card>
    </div>
};

export default Wizard;
